import React from 'react';
import BaseScadaNode from './BaseScadaNode';

/**
 * 3-way valve SVG (ISA style T-junction):
 * - 1 inlet (left)
 * - 2 outlets (top and bottom)
 * State: boolean — true = flow to top, false = flow to bottom
 */
export function Valve3WaySVG({ value, config, width = 60, height = 60 }) {
    const isA = parseFloat(value ?? 0) >= parseFloat(config?.threshold ?? 0.5);
    const colorA = config?.on_color || '#22C55E';
    const colorB = config?.off_color || '#94A3B8';
    const cx = width / 2;
    const cy = height / 2;
    const r = Math.min(width, height) * 0.12;
    const arm = Math.min(width, height) * 0.32;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Center body */}
            <circle cx={cx} cy={cy} r={r * 1.4} fill="#1E293B" stroke="#475569" strokeWidth={1.5} />

            {/* Left inlet arm */}
            <line x1={cx - arm} y1={cy} x2={cx - r * 1.4} y2={cy} stroke="#94A3B8" strokeWidth={4} strokeLinecap="round" />
            {/* Triangle ISA valve symbol pointing left */}
            <polygon
                points={`${cx - r * 1.4},${cy - r} ${cx - r * 1.4},${cy + r} ${cx - r * 2.6},${cy}`}
                fill="#64748B" stroke="#94A3B8" strokeWidth={1}
            />

            {/* Top outlet arm — color = A position */}
            <line x1={cx} y1={cy - r * 1.4} x2={cx} y2={cy - arm} stroke={isA ? colorA : '#475569'} strokeWidth={4} strokeLinecap="round" />
            <polygon
                points={`${cx - r},${cy - r * 1.4} ${cx + r},${cy - r * 1.4} ${cx},${cy - r * 2.6}`}
                fill={isA ? colorA : '#334155'} stroke={isA ? colorA : '#475569'} strokeWidth={1}
            />

            {/* Bottom outlet arm — color = B position */}
            <line x1={cx} y1={cy + r * 1.4} x2={cx} y2={cy + arm} stroke={!isA ? colorB : '#475569'} strokeWidth={4} strokeLinecap="round" />
            <polygon
                points={`${cx - r},${cy + r * 1.4} ${cx + r},${cy + r * 1.4} ${cx},${cy + r * 2.6}`}
                fill={!isA ? colorB : '#334155'} stroke={!isA ? colorB : '#475569'} strokeWidth={1}
            />

            {/* State label */}
            {value != null && (
                <text x={cx} y={cy + r * 0.4} textAnchor="middle" fontSize={r * 0.9} fill="#F1F5F9" fontWeight="bold">
                    {isA ? 'A' : 'B'}
                </text>
            )}
        </svg>
    );
}

export default function Valve3WayNode({ data, selected }) {
    const lv = data?.config?.variables?.state?.variable_data_id != null ? data?.liveValues?.state : undefined;
    return (
        <BaseScadaNode data={data} selected={selected}>
            <Valve3WaySVG
                value={lv}
                config={data?.config}
                width={data?.width || 60}
                height={data?.height || 60}
            />
            {data?.label ? (
                <div style={{ position: 'absolute', bottom: -18, left: 0, right: 0, textAlign: 'center', fontSize: 10, color: '#94A3B8', pointerEvents: 'none' }}>
                    {data.label}
                </div>
            ) : null}
        </BaseScadaNode>
    );
}
